<nav class="catalog__filters" role="navigation">
  <div *ngFor="let filterOptions of filters; trackBy: trackByFilter">
    <vc-catalog-widget-checkbox-list
      *ngIf="ofType(filterOptions, 'checkbox-list')"
      [ngClass]="{'d-none': isHiddenFilter(filterOptions)}"
      [showRefinementBody]="showRefinementBody"
      [options]="filterOptions"
      [pageRouteParameter]="routeParameters"
      [facetLink]="facetLink"
      (refined)="scrollTop($event)"
      [nbHits]="getFacetHits(filterOptions.facet)"
      (clickFilter)="clickFilter($event)"
    ></vc-catalog-widget-checkbox-list>

    <vc-catalog-widget-hierarchical-menu
      *ngIf="ofType(filterOptions, 'hierarchical-menu')"
      [ngClass]="{'d-none': isHiddenFilter(filterOptions)}"
      [showRefinementBody]="showRefinementBody"
      [options]="filterOptions"
      [pageRouteParameter]="routeParameters"
      [facetLink]="facetLink"
      (refined)="scrollTop($event)"
      (clickFilter)="clickFilter($event)"
    ></vc-catalog-widget-hierarchical-menu>

    <vc-catalog-widget-price-range
      *ngIf="ofType(filterOptions, 'price-range')"
      [applyPriceFilter]="applyPriceFilter"
      [ngClass]="{'d-none': isHiddenFilter(filterOptions)}"
      [showRefinementBody]="showRefinementBody"
      [options]="filterOptions"
      [pageRouteParameter]="routeParameters"
      [facetLink]="facetLink"
      (clickFilter)="clickFilter($event)"
    ></vc-catalog-widget-price-range>

    <vc-catalog-widget-short-checkbox-list
      *ngIf="ofType(filterOptions, 'short-checkbox-list')"
      [ngClass]="{'d-none': isHiddenFilter(filterOptions)}"
      [showRefinementBody]="showRefinementBody"
      [options]="filterOptions"
      [pageRouteParameter]="routeParameters"
      [facetLink]="facetLink"
      (refined)="scrollTop($event)"
      (clickFilter)="clickFilter($event)"
    >
    </vc-catalog-widget-short-checkbox-list>

    <vc-catalog-widget-toggle
      *ngIf="ofType(filterOptions, 'toggle') && (filterOptions.facet !== 'dsEligibleCountries' || userDSeligibility)"
      [ngClass]="{'d-none': isHiddenFilter(filterOptions)}"
      [showRefinementBody]="showRefinementBody"
      [isMobile]="isMobile"
      [options]="filterOptions"
      [pageRouteParameter]="routeParameters"
      [facetLink]="facetLink"
      [currentCountry]="currentCountry"
      [marketingFilterLocal]="marketingFilterLocal"
      [currentDeal]="currentDeal"
      (refined)="scrollTop($event)"
      (clickFilter)="clickFilter($event)"
    ></vc-catalog-widget-toggle>

    <vc-catalog-widget-colors
      *ngIf="ofType(filterOptions, 'colors')"
      [ngClass]="{'d-none': isHiddenFilter(filterOptions)}"
      [showRefinementBody]="showRefinementBody"
      [options]="filterOptions"
      [pageRouteParameter]="routeParameters"
      [facetLink]="facetLink"
      (refined)="scrollTop($event)"
      (clickFilter)="clickFilter($event)"
    ></vc-catalog-widget-colors>

    <vc-catalog-widget-locations-checkbox-list
      #countryFilter
      *ngIf="ofType(filterOptions, 'locations-checkbox-list')"
      [ngClass]="{'d-none': isHiddenFilter(filterOptions)}"
      [showRefinementBody]="showRefinementBody"
      [options]="filterOptions"
      [pageRouteParameter]="routeParameters"
      [facetLink]="facetLink"
      [currentCountry]="currentCountry"
      (refined)="scrollTop($event)"
      (clickFilter)="clickFilter($event)"
    ></vc-catalog-widget-locations-checkbox-list>
  </div>
</nav>
